import EnableChapterIcon from '@mui/icons-material/Check';
import DisableChapterIcon from '@mui/icons-material/Close';
import React from 'react';
import { Badge } from 'reactstrap';

import { DisableChapterModal } from '../DisableChapterModal';

function VisibilityBadge({ isDisabled, onDisabled, isMobile }) {
  const local = window.location.hash;
  const isInStudy = local === '#/app/study';
  const isInQualsAndCerts = local === '#/app/study/quals-and-certs';

  const [disableChapterModalIsOpen, setDisableChapterModalIsOpen] =
    React.useState(false);

  const getIconStyles = () => {
    if (isMobile) {
      return {
        fontSize: 'small',
        style: {
          paddingRight: '5px',
          paddingBottom: '5px',
        },
      };
    }
    return {
      fontSize: 'small',
      style: {
        paddingRight: '2px',
        paddingBottom: '2px',
      },
    };
  };

  const getBadgeStyles = () => {
    if (isMobile) {
      return {
        color: 'default',
        className: 'circle',
        pill: true,
      };
    }
    return {
      color: 'outline',
      className: 'circle mr-2',
      pill: false,
    };
  };

  if (isInStudy || isInQualsAndCerts) {
    if (isDisabled) {
      return (
        <Badge {...getBadgeStyles()} onClick={onDisabled}>
          <EnableChapterIcon {...getIconStyles()} />
        </Badge>
      );
    }
    return (
      <>
        <Badge
          {...getBadgeStyles()}
          onClick={() => {
            setDisableChapterModalIsOpen(true);
          }}
        >
          <DisableChapterIcon {...getIconStyles()} />
        </Badge>
        <DisableChapterModal
          isOpen={disableChapterModalIsOpen}
          toggle={() =>
            setDisableChapterModalIsOpen(!disableChapterModalIsOpen)
          }
          onDisabledClick={onDisabled}
        />
      </>
    );
  }
  return <></>;
}

export default VisibilityBadge;
